module.exports = __webpack_public_path__ + "static/media/upload_file.0b74c33f.svg";